import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { FileText, FileSpreadsheet } from "lucide-react";

export default function ExportButtons({ endpoint, label }) {
  const [exporting, setExporting] = useState("");

  const handleExport = async (format) => {
    setExporting(format);
    try {
      const sep = endpoint.includes("?") ? "&" : "?";
      const url = `${endpoint}${sep}format=${format}`;
      const response = await api.get(url, { responseType: "blob" });
      const contentDisposition = response.headers["content-disposition"] || "";
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : `${label}.${format === "pdf" ? "pdf" : "xlsx"}`;
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
      toast.success(`Đã xuất ${format.toUpperCase()}`);
    } catch (err) {
      toast.error(`Lỗi khi xuất ${format.toUpperCase()}`);
    } finally {
      setExporting("");
    }
  };

  return (
    <div className="flex gap-1.5">
      <button
        onClick={() => handleExport("pdf")}
        disabled={!!exporting}
        className="flex items-center gap-1 text-xs text-slate-400 hover:text-red-400 border border-[#334155] rounded-md px-2.5 py-1.5 transition-colors disabled:opacity-50"
        data-testid="export-pdf-btn"
      >
        <FileText className="w-3.5 h-3.5" />
        {exporting === "pdf" ? "..." : "PDF"}
      </button>
      <button
        onClick={() => handleExport("excel")}
        disabled={!!exporting}
        className="flex items-center gap-1 text-xs text-slate-400 hover:text-lime-400 border border-[#334155] rounded-md px-2.5 py-1.5 transition-colors disabled:opacity-50"
        data-testid="export-excel-btn"
      >
        <FileSpreadsheet className="w-3.5 h-3.5" />
        {exporting === "excel" ? "..." : "Excel"}
      </button>
    </div>
  );
}
